/**
 * This file holds repository-wide constants that are reusable by more than 1 component.
 */
/**
 * A delay [ms] after which it's OK to update a live region content,
 * taking under consideration delayed programmatic refocusing
 * of triggering components (e.g., SelectInput) and Accessibility
 * Tree updates that prevent the screen reader announcements.
 */
const WDS_LIVE_REGION_DELAY_MS = 175;

export { WDS_LIVE_REGION_DELAY_MS };
//# sourceMappingURL=constants.mjs.map
